import React, {useState} from 'react';
import {Redirect, useParams} from 'react-router-dom';

const CabForm = ({api}) => {

    const [cabName, setCabName] = useState("");
    const [cabId, setCabId] = useState("");
    const [pdu1Type, setPdu1Type] = useState("EmersonPdu");
    const [pdu2Type, setPdu2Type] = useState("EmersonPdu");
    const [formError, setFormError] = useState("");
    const [formDone, setFormDone] = useState(false);

    const params = useParams();
    const dcId = params.dcId;

    const parseFormErrors = (errData) => {
        let keys = Object.keys(errData);
        let errString = "";
        keys.forEach(key => {
            if (!errData.hasOwnProperty(key)) return;
            errData[key].forEach(errMsg => {
                errString += `${key} ${errMsg}. `
            })
        });
        return errString;
    }

    const createCab = async(evt) => {
        evt.preventDefault();
        setFormError('');
        let result = await api.createCab(dcId, cabId, cabName, pdu1Type, pdu2Type).catch(err => {
            if(err.response.status === 422) {
                setFormError(parseFormErrors(err.response.data));
            } else {
                setFormError(err.message);
            }
        });
        console.log(result);
        if(!!result) {
            setFormDone(true);
        }
    }

    const cabIdChange = (evt) => {
        setCabId(evt.target.value);
    }

    const cabNameChange = (evt) => {
        setCabName(evt.target.value);
    }

    const pdu1TypeChange = (evt) => {
        setPdu1Type(evt.target.value);
    }

    const pdu2TypeChange = (evt) => {
        setPdu2Type(evt.target.value);
    }

    if(formDone) {
        return <Redirect to="/"></Redirect>
    }

    return <form className="LoginForm" onSubmit={createCab}>
        <div className="form-group">
            <label htmlFor="cabId">Cab ID</label>
            <input type="text" className="form-control" required pattern="[a-zA-Z0-9]{2,4}" title="Cab ID must be 2 to 4 alphanumeric characters" id="cabId" value={cabId} onChange={cabIdChange} />
        </div>
        <div className="form-group">
            <label htmlFor="cabName">Cab Name</label>
            <input type="text" className="form-control" required id="cabName" value={cabName} onChange={cabNameChange} />
        </div>
        <div className="form-group">
            <label htmlFor="pdu1Type">PDU 1 Type</label>
            <select className="form-control" id="pdu1Type" value={pdu1Type} onChange={pdu1TypeChange}>
                <option value="EmersonPdu">Emerson</option>
                <option value="ApcPdu">APC</option>
            </select>
        </div>
        <div className="form-group">
            <label htmlFor="pdu2Type">PDU 2 Type</label>
            <select className="form-control" id="pdu2Type" value={pdu2Type} onChange={pdu2TypeChange}>
                <option value="EmersonPdu">Emerson</option>
                <option value="ApcPdu">APC</option>
            </select>
        </div>
        <span className="text-danger">{formError}</span>
        <button type="submit" className="btn btn-primary float-right">Submit</button>
    </form>
}

export default CabForm;